// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStatusQuestionMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.019 14.5a.532.532 0 0 1-.52.5h-1a.5.5 0 0 1-.5-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2-.928 0-1.715.642-1.937 1.505C9.994 8.773 9.776 9 9.5 9h-1c-.276 0-.503-.225-.47-.499A4 4 0 0 1 16 9c0 .88-.36 1.68-.93 2.25l-.9.92c-.634.643-1.059 1.185-1.151 2.33zm-1.52 4.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStatusQuestionMark;
